var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"editable",rawName:"v-editable",value:(_vm.blok),expression:"blok"}],class:_vm.styles,domProps:{"innerHTML":_vm._s(_vm.blok.copy.html)}})}
var staticRenderFns = []

export { render, staticRenderFns }